<template>
  <div
    class="modal fade"
    id="editAddressModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editAddressModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('location.addressTitle') }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-row">
              <!-- Province -->
              <div class="form-group col-md-4">
                <label for="provinceList">{{ $t('location.province') }}</label>
                <select
                  class="selectbox-gender form-control"
                  v-model="address.province"
                  @change="onChangedProvince()"
                  style="font-size:14px;"
                >
                  <option
                    v-for="province in provinceList"
                    :key="province.value"
                    v-bind:value="province.value">
                    {{ province.text }}
                  </option>
                </select>
              </div>
              <!-- District -->
              <div class="form-group col-md-4">
                <label for="districtList">{{ $t('location.district') }}</label>
                <select
                  class="selectbox-gender form-control"
                  v-model="address.district"
                  @change="onChangedDistrict()"
                  style="font-size:14px;"
                >
                  <option
                    v-for="district in districtList"
                    :key="district.value"
                    v-bind:value="district.value">
                    {{ district.text }}
                  </option>
                </select>
              </div>
              <!-- Ward -->
              <div class="form-group col-md-4">
                <label for="wardList">{{ $t('location.ward') }}</label>
                <select
                  class="selectbox-gender form-control"
                  v-model="address.ward"
                  style="font-size:14px;"
                >
                  <option
                    v-for="ward in wardList"
                    :key="ward.value"
                    v-bind:value="ward.value">
                    {{ ward.text }}
                  </option>
                </select>
              </div>
              <!-- Street -->
              <div class="form-group col-md-12">
                <label for="street">{{ $t('location.address') }}</label>
                <textarea
                  v-model="address.street"
                  type="text"
                  class="form-control"
                  :placeholder="$t('location.address')"
                ></textarea>
              </div>
              <!-- Longitude -->
              <div v-if="isEnableGeologic" class="form-group col-md-6">
                <label for="longitude">{{ $t('location.longitude') }}</label>
                <input
                  v-model="address.longitude"
                  type="text"
                  class="form-control"
                  :placeholder="$t('location.longitude')"
                />
              </div>
              <!-- Latitude -->
              <div v-if="isEnableGeologic" class="form-group col-md-6">
                <label for="latitude">{{ $t('location.latitude') }}</label>
                <input
                  v-model="address.latitude"
                  type="text"
                  class="form-control"
                  :placeholder="$t('location.latitude')"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            {{ $t('common.close') }}
          </button>
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onConfirm">{{ $t('common.confirm')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'

export default {
  data: () => ({
    isEnableGeologic: false,
    address: {
      longitude: null,
      latitude: null,
      country: 84,
      province: null,
      district: null,
      ward: null,
      street: ''
    },
    provinceList: [{ text: '---', value: null }],
    districtList: [{ text: '---', value: null }],
    wardList: [{ text: '---', value: null }],
  }),
  methods: {
    getProvinceList: function () {
      this.GET_LIST_PROVINCE({ id: this.address.country }).then(
        function (res) {
          var isFound = false
          let data = res.data
          this.provinceList = [{ text: '---', value: null }]
          for (let i = 0, size = data.length; i < size; i++) {
            let provinceObj = {
              value: data[i].code,
              text: data[i].type + ' ' + data[i].name
            }
            this.provinceList.push(provinceObj)
            if (data[i].code === this.address.province) {
              isFound = true
            }
          }
          if (isFound) {
            this.getDistrictList()
          }
        }.bind(this)
      )
    },
    getDistrictList: function () {
      if (this.address.province > 0) {
        this.GET_LIST_DISTRICT({ id: this.address.province }).then(
          function (res) {
            var isFound = false
            let data = res.data
            this.districtList = [{ text: '---', value: null }]
            for (let i = 0, size = data.length; i < size; i++) {
              let districtObj = {
                value: data[i].code,
                text: data[i].type + ' ' + data[i].name
              }
              this.districtList.push(districtObj)
              if (data[i].code === this.address.district) {
                isFound = true
              }
            }
            if (isFound) {
              this.getWardList()
            }
          }.bind(this)
        )
      } else {
        this.districtList = [{ text: '---', value: null }]
        this.address.district = 0
        // this.getWardList()
      }
    },
    getWardList: function () {
      if (this.address.district) {
        this.GET_LIST_WARD({ id: this.address.district }).then(
          function (res) {
            let data = res.data
            this.wardList = [{ text: '---', value: null }]
            for (let i = 0, size = data.length; i < size; i++) {
              let wardObj = {
                value: data[i].code,
                text: data[i].type + ' ' + data[i].name
              }
              this.wardList.push(wardObj)
            }
          }.bind(this)
        )
      } else {
        this.wardList = [{ text: '---', value: null }]
        this.address.ward = 0
      }
    },
    onChangedProvince: function () {
      // this.address.district = 0
      this.districtList = [{ text: '---', value: null }]
      // this.address.ward = 0
      this.wardList = [{ text: '---', value: null }]
      this.getDistrictList()
    },
    onChangedDistrict: function () {
      // this.address.ward = 0
      this.wardList = [{ text: '---', value: null }]
      this.getWardList()
    },
    onShowModal: function (address, isEnableGeologic) {
      this.isEnableGeologic = isEnableGeologic
      this.address.province = address.province
      this.address.district = address.district
      this.address.ward = address.ward
      this.address.longitude = address.longitude
      this.address.latitude = address.latitude
      this.address.street = address.street
      this.getProvinceList()
      $("#editAddressModal").modal('show')
    },
    onConfirm: function (event) {
      event.preventDefault()
      this.$emit('onConfirm', this.address)
      $("#editAddressModal").modal('hide')
    },
    ...mapActions([
      'ON_SHOW_TOAST',
      'GET_LIST_PROVINCE',
      'GET_LIST_DISTRICT',
      'GET_LIST_WARD'
    ])
  }
}

</script>

<style lang="scss" scoped>
</style>
